import * as React from 'react';

import HeaderMenuButton from '../../../shared/components/header/HeaderMenuButton';
import HeaderUserName from '../../../shared/components/header/HeaderUserName';
import BaseHeaderView from '../../shared/header/BaseHeaderView';
import MobileStudentHeaderMenu from './components/MobileStudentHeaderMenu';

interface StudentHeaderViewProps {
  model: {
    mobileMenuVisible: boolean;
  };
  [key: string]: any;
}
const StudentHeaderView = (props: StudentHeaderViewProps) => {
  const {
    model: { mobileMenuVisible },
  } = props;

  return (
    <BaseHeaderView {...props}>
      <HeaderMenuButton {...props} />
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <HeaderUserName {...props} />
        {mobileMenuVisible ? (
          <MobileStudentHeaderMenu {...(props as any)} />
        ) : null}
      </div>
    </BaseHeaderView>
  );
};

export default StudentHeaderView;
